// // import React, { useEffect, useState } from "react";
// // import { motion } from "framer-motion";
// // import {
// //   FiUsers, FiLogIn, FiActivity, FiSearch, FiTrash2,
// //   FiLock, FiLogOut, FiChevronLeft, FiChevronRight,
// //   FiShield, FiBarChart2, FiPieChart, FiAlertCircle,
// //   FiX,
// //   FiUnlock
// // } from "react-icons/fi";
// // import {
// //   collection, onSnapshot, deleteDoc, doc, getDocs,
// //   query, where, updateDoc
// // } from "firebase/firestore";
// // import { db } from "./firebase";
// // import Navbar from "./Navbar";
// // import { useNavigate } from "react-router-dom";
// // import { ToastContainer, toast } from "react-toastify";
// // import {
// //   BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
// //   PieChart, Pie, Cell, LineChart, Line
// // } from "recharts";
// // import "react-toastify/dist/ReactToastify.css";
// // import "./AdminDashboard.css";

// // // ─── Stat Card ─────────────────────────────────────────────────
// // function StatCard({ icon, label, value, color, delay }) {
// //   return (
// //     <motion.div
// //       className="stat-card"
// //       initial={{ opacity: 0, y: 20 }}
// //       whileInView={{ opacity: 1, y: 0 }}
// //       viewport={{ once: true }}
// //       transition={{ delay, duration: 0.5 }}
// //       whileHover={{ y: -4 }}
// //       style={{ "--stat-color": color }}
// //     >
// //       <div className="stat-icon">{icon}</div>
// //       <div className="stat-info">
// //         <span className="stat-value">{value}</span>
// //         <span className="stat-label">{label}</span>
// //       </div>
// //     </motion.div>
// //   );
// // }

// // // ─── Chart Card ────────────────────────────────────────────────
// // function ChartCard({ title, icon, children }) {
// //   return (
// //     <motion.div
// //       className="chart-card"
// //       initial={{ opacity: 0, y: 20 }}
// //       whileInView={{ opacity: 1, y: 0 }}
// //       viewport={{ once: true }}
// //     >
// //       <div className="chart-header">
// //         <span className="chart-icon">{icon}</span>
// //         <h3>{title}</h3>
// //       </div>
// //       <div className="chart-body">{children}</div>
// //     </motion.div>
// //   );
// // }

// // // ─── Access Denied ─────────────────────────────────────────────
// // function AccessDenied() {
// //   return (
// //     <div className="access-denied">
// //       <div className="access-denied-content">
// //         <div className="access-icon"><FiAlertCircle /></div>
// //         <h2>Access Denied</h2>
// //         <p>You don't have permission to view this page.</p>
// //       </div>
// //     </div>
// //   );
// // }

// // // ─── Custom Tooltip ────────────────────────────────────────────
// // function CustomTooltip({ active, payload, label }) {
// //   if (!active || !payload?.length) return null;
// //   return (
// //     <div className="custom-tooltip">
// //       <p className="tooltip-label">{label}</p>
// //       {payload.map((item, i) => (
// //         <p key={i} className="tooltip-value" style={{ color: item.color }}>
// //           {item.name}: {item.value}
// //         </p>
// //       ))}
// //     </div>
// //   );
// // }

// // // ─── Main Dashboard Component ──────────────────────────────────
// // export default function AdminDashboard() {
// //   const [logins, setLogins] = useState([]);
// //   const [users, setUsers] = useState([]);
// //   const [user, setUser] = useState(null);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [loading, setLoading] = useState(true);
// //   const rowsPerPage = 10;
// //   const navigate = useNavigate();
// //   const adminEmail = "karanksxxx@gmail.com";

// //   // Fetch data
// //   useEffect(() => {
// //     const current = JSON.parse(localStorage.getItem("user"));
// //     setUser(current);

// //     getDocs(collection(db, "Register")).then((snap) => {
// //       setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
// //     });

// //     const unsub = onSnapshot(collection(db, "Login"), (snap) => {
// //       setLogins(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
// //       setLoading(false);
// //     });

// //     return () => unsub();
// //   }, []);

// //   if (!user || user.Email !== adminEmail) {
// //     return <AccessDenied />;
// //   }

// //   // Graph data
// //   const loginCountPerUser = logins.reduce((acc, l) => {
// //     acc[l.Email] = (acc[l.Email] || 0) + 1;
// //     return acc;
// //   }, {});

// //   const graphData = Object.keys(loginCountPerUser).map((email) => ({
// //     email: email.split("@")[0],
// //     logins: loginCountPerUser[email],
// //   }));

// //   const activeCount = users.filter((u) => !u.blocked).length;
// //   const blockedCount = users.filter((u) => u.blocked).length;

// //   const pieData = [
// //     { name: "Active", value: activeCount },
// //     { name: "Blocked", value: blockedCount },
// //   ];

// //   const COLORS = ["#22c55e", "#f43f5e"];

// //   // Merge users with login data
// //   const mergedUsers = users.map((u) => ({
// //     ...u,
// //     loginCount: loginCountPerUser[u.Email] || 0,
// //     lastLogin: logins
// //       .filter((log) => log.Email === u.Email)
// //       .sort((a, b) => new Date(b.LoginTime) - new Date(a.LoginTime))[0]?.LoginTime || null,
// //   }));

// //   // Filter and search
// //   const filteredUsers = mergedUsers
// //     .filter((u) => (u.Name || "").toLowerCase().includes(searchQuery.toLowerCase()))
// //     .sort((a, b) => (a.Email === adminEmail ? -1 : 0));

// //   // Pagination
// //   const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
// //   const displayedUsers = filteredUsers.slice(
// //     (currentPage - 1) * rowsPerPage,
// //     currentPage * rowsPerPage
// //   );

// //   // Actions
// //   const blockUser = async (email) => {
// //     const userDoc = users.find((u) => u.Email === email);
// //     await updateDoc(doc(db, "Register", userDoc.id), { blocked: true });
// //     toast.warning(`${email} blocked.`);
// //   };

// //   const unblockUser = async (email) => {
// //     const userDoc = users.find((u) => u.Email === email);
// //     await updateDoc(doc(db, "Register", userDoc.id), { blocked: false });
// //     toast.success(`${email} unblocked.`);
// //   };

// //   const deleteLoginHistory = async (email) => {
// //     const snap = await getDocs(query(collection(db, "Login"), where("Email", "==", email)));
// //     await Promise.all(snap.docs.map((d) => deleteDoc(doc(db, "Login", d.id))));
// //     toast.success(`Deleted login history for ${email}`);
// //   };

// //   const logout = () => {
// //     localStorage.removeItem("user");
// //     navigate("/login");
// //   };

// //   function formatTimestamp(ts) {
// //     if (!ts) return "N/A";
// //     return ts.toDate ? ts.toDate().toLocaleString() : new Date(ts.seconds * 1000).toLocaleString();
// //   }

// //   return (
// //     <div className="dashboard-page">
// //       <ToastContainer
// //         position="top-right"
// //         autoClose={3000}
// //         hideProgressBar
// //         theme="dark"
// //         toastStyle={{
// //           background: "#0d0d14",
// //           border: "1px solid rgba(255,255,255,0.1)",
// //           color: "#f0f0f5",
// //         }}
// //       />

// //       {/* ═══════════ HERO ═══════════ */}
// //       <section className="dashboard-hero">
// //         <div className="dashboard-hero-bg" />
// //         <motion.div
// //           className="dashboard-hero-content"
// //           initial={{ opacity: 0, y: 30 }}
// //           animate={{ opacity: 1, y: 0 }}
// //           transition={{ duration: 0.8 }}
// //         >
// //           <span className="dashboard-tag"><FiShield /> ADMIN</span>
// //           <h1 className="dashboard-hero-title">
// //             Analytics <span className="gradient-text">Dashboard</span>
// //           </h1>
// //           <p className="dashboard-hero-subtitle">
// //             Monitor users, logins, and platform activity in real-time.
// //           </p>
// //         </motion.div>
// //       </section>

// //       {/* ═══════════ MAIN ═══════════ */}
// //       <main className="dashboard-main">
// //         <div className="dashboard-container">

// //           {/* Stats */}
// //           <div className="stats-grid">
// //             <StatCard
// //               icon={<FiUsers />}
// //               label="Total Users"
// //               value={users.length}
// //               color="#6366f1"
// //               delay={0.1}
// //             />
// //             <StatCard
// //               icon={<FiLogIn />}
// //               label="Total Logins"
// //               value={logins.length}
// //               color="#a855f7"
// //               delay={0.2}
// //             />
// //             <StatCard
// //               icon={<FiActivity />}
// //               label="Active Users"
// //               value={activeCount}
// //               color="#22c55e"
// //               delay={0.3}
// //             />
// //             <StatCard
// //               icon={<FiLock />}
// //               label="Blocked Users"
// //               value={blockedCount}
// //               color="#f43f5e"
// //               delay={0.4}
// //             />
// //           </div>

// //           {/* Charts */}
// //           <div className="charts-grid">
// //             <ChartCard title="Logins Per User" icon={<FiBarChart2 />}>
// //               <ResponsiveContainer width="100%" height={250}>
// //                 <BarChart data={graphData}>
// //                   <XAxis dataKey="email" tick={{ fill: "#555570", fontSize: 11 }} axisLine={false} tickLine={false} />
// //                   <YAxis tick={{ fill: "#555570", fontSize: 11 }} axisLine={false} tickLine={false} />
// //                   <Tooltip content={<CustomTooltip />} />
// //                   <Bar dataKey="logins" fill="#6366f1" radius={[6, 6, 0, 0]} />
// //                 </BarChart>
// //               </ResponsiveContainer>
// //             </ChartCard>

// //             <ChartCard title="User Status" icon={<FiPieChart />}>
// //               <ResponsiveContainer width="100%" height={250}>
// //                 <PieChart>
// //                   <Pie data={pieData} dataKey="value" outerRadius={90} innerRadius={50} label>
// //                     {pieData.map((_, i) => (
// //                       <Cell key={i} fill={COLORS[i]} />
// //                     ))}
// //                   </Pie>
// //                   <Tooltip content={<CustomTooltip />} />
// //                 </PieChart>
// //               </ResponsiveContainer>
// //             </ChartCard>
// //           </div>

// //           {/* User Table */}
// //           <motion.div
// //             className="table-section"
// //             initial={{ opacity: 0, y: 20 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //           >
// //             <div className="table-header">
// //               <div>
// //                 <span className="table-tag"><FiUsers /> USERS</span>
// //                 <h2>User Activity <span className="gradient-text">Table</span></h2>
// //               </div>
// //               <div className="table-actions">
// //                 <div className="search-wrapper">
// //                   <FiSearch className="search-icon" />
// //                   <input
// //                     type="text"
// //                     placeholder="Search users..."
// //                     value={searchQuery}
// //                     onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
// //                     className="search-input"
// //                   />
// //                   {searchQuery && (
// //                     <button className="search-clear" onClick={() => { setSearchQuery(""); setCurrentPage(1); }}>
// //                       <FiX />
// //                     </button>
// //                   )}
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="table-wrapper">
// //               <table className="data-table">
// //                 <thead>
// //                   <tr>
// //                     <th>#</th>
// //                     <th>Profile</th>
// //                     <th>Name</th>
// //                     <th>Email</th>
// //                     <th>Contact</th>
// //                     <th>Last Login</th>
// //                     <th>Logins</th>
// //                     <th>Actions</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {displayedUsers.map((u, index) => (
// //                     <tr key={u.Email} className={u.Email === adminEmail ? "admin-row" : ""}>
// //                       <td className="row-number">{(currentPage - 1) * rowsPerPage + index + 1}</td>
// //                       <td>
// //                         <img src={u.PhotoURL || "default-avatar.png"} className="user-avatar" alt="avatar" />
// //                       </td>
// //                       <td className="user-name">{u.Name || "N/A"}</td>
// //                       <td className="user-email">{u.Email}</td>
// //                       <td>{u.Contact || "N/A"}</td>
// //                       <td className="timestamp">{formatTimestamp(u.lastLogin)}</td>
// //                       <td>
// //                         <span className="login-badge">{u.loginCount}</span>
// //                       </td>
// //                       <td>
// //                         <div className="action-buttons">
// //                           <motion.button
// //                             className="action-btn clear-btn"
// //                             onClick={() => deleteLoginHistory(u.Email)}
// //                             whileHover={{ scale: 1.05 }}
// //                             whileTap={{ scale: 0.95 }}
// //                             title="Clear Logs"
// //                           >
// //                             <FiTrash2 />
// //                           </motion.button>
// //                           {u.Email !== adminEmail && (
// //                             u.blocked ? (
// //                               <motion.button
// //                                 className="action-btn unblock-btn"
// //                                 onClick={() => unblockUser(u.Email)}
// //                                 whileHover={{ scale: 1.05 }}
// //                                 whileTap={{ scale: 0.95 }}
// //                                 title="Unblock"
// //                               >
// //                                 <FiUnlock />
// //                               </motion.button>
// //                             ) : (
// //                               <motion.button
// //                                 className="action-btn block-btn"
// //                                 onClick={() => blockUser(u.Email)}
// //                                 whileHover={{ scale: 1.05 }}
// //                                 whileTap={{ scale: 0.95 }}
// //                                 title="Block"
// //                               >
// //                                 <FiLock />
// //                               </motion.button>
// //                             )
// //                           )}
// //                         </div>
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>

// //             {/* Pagination */}
// //             {totalPages > 1 && (
// //               <div className="table-pagination">
// //                 <motion.button
// //                   className="page-btn"
// //                   disabled={currentPage === 1}
// //                   onClick={() => setCurrentPage((p) => p - 1)}
// //                   whileHover={{ scale: 1.05 }}
// //                 >
// //                   <FiChevronLeft />
// //                 </motion.button>
// //                 <span className="page-info">{currentPage} / {totalPages}</span>
// //                 <motion.button
// //                   className="page-btn"
// //                   disabled={currentPage === totalPages}
// //                   onClick={() => setCurrentPage((p) => p + 1)}
// //                   whileHover={{ scale: 1.05 }}
// //                 >
// //                   <FiChevronRight />
// //                 </motion.button>
// //               </div>
// //             )}
// //           </motion.div>

// //           {/* Logout */}
// //           <div className="logout-section">
// //             <motion.button
// //               className="logout-btn"
// //               onClick={logout}
// //               whileHover={{ scale: 1.03 }}
// //               whileTap={{ scale: 0.97 }}
// //             >
// //               <FiLogOut /> Logout
// //             </motion.button>
// //           </div>
// //         </div>
// //       </main>

// //       <Navbar />
// //     </div>
// //   );
// // }



// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence, useScroll, useSpring } from "framer-motion";
// import {
//   FiUsers, FiLogIn, FiActivity, FiSearch, FiTrash2,
//   FiLock, FiLogOut, FiChevronLeft, FiChevronRight,
//   FiShield, FiBarChart2, FiPieChart, FiAlertCircle,
//   FiX,
//   FiUnlock
// } from "react-icons/fi";
// import {
//   collection, onSnapshot, deleteDoc, doc, getDocs,
//   query, where, updateDoc
// } from "firebase/firestore";
// import { db } from "./firebase";
// import Navbar from "./Navbar";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
//   PieChart, Pie, Cell, LineChart, Line
// } from "recharts";
// import "react-toastify/dist/ReactToastify.css";
// import "./AdminDashboard.css";

// /* ═══════════════ DEMO DATA (preview only — never used with real db) ═══════════════ */

// const ADMIN_EMAIL = "karanksxxx@gmail.com";
// const now = Math.floor(Date.now() / 1000);
// const DEMO_USERS = [
//   { id: "u1", Name: "Karan Kumar", Email: ADMIN_EMAIL, Contact: "9041429065", PhotoURL: "", blocked: false },
//   { id: "u2", Name: "Aarav Sharma", Email: "aarav@gmail.com", Contact: "9814012345", PhotoURL: "", blocked: false },
//   { id: "u3", Name: "Simran Kaur", Email: "simran@gmail.com", Contact: "9876543210", PhotoURL: "", blocked: false },
//   { id: "u4", Name: "Rohan Verma", Email: "rohan@gmail.com", Contact: "9000011122", PhotoURL: "", blocked: true },
//   { id: "u5", Name: "Priya Singh", Email: "priya@gmail.com", Contact: "9888011223", PhotoURL: "", blocked: false },
//   { id: "u6", Name: "Arjun Mehta", Email: "arjun@gmail.com", Contact: "9777011223", PhotoURL: "", blocked: false },
// ];
// const DEMO_LOGINS = [
//   { id: "l1", Email: ADMIN_EMAIL, LoginTime: { seconds: now - 3600 } },
//   { id: "l2", Email: ADMIN_EMAIL, LoginTime: { seconds: now - 7200 } },
//   { id: "l3", Email: "aarav@gmail.com", LoginTime: { seconds: now - 5000 } },
//   { id: "l4", Email: "aarav@gmail.com", LoginTime: { seconds: now - 90000 } },
//   { id: "l5", Email: "aarav@gmail.com", LoginTime: { seconds: now - 200000 } },
//   { id: "l6", Email: "simran@gmail.com", LoginTime: { seconds: now - 8000 } },
//   { id: "l7", Email: "simran@gmail.com", LoginTime: { seconds: now - 95000 } },
//   { id: "l8", Email: "rohan@gmail.com", LoginTime: { seconds: now - 300000 } },
//   { id: "l9", Email: "priya@gmail.com", LoginTime: { seconds: now - 12000 } },
//   { id: "l10", Email: "arjun@gmail.com", LoginTime: { seconds: now - 60000 } },
//   { id: "l11", Email: "arjun@gmail.com", LoginTime: { seconds: now - 150000 } },
// ];

// // ─── Floating Particles ────────────────────────────────────────
// function DashParticles() {
//   const parts = React.useRef(
//     Array.from({ length: 20 }, (_, i) => ({
//       id: i, x: Math.random() * 100, y: Math.random() * 100,
//       s: Math.random() * 3 + 1, d: Math.random() * 12 + 8, dl: Math.random() * 5,
//     }))
//   );
//   return (
//     <div className="ad-particles">
//       {parts.current.map((p) => (
//         <motion.span
//           key={p.id}
//           className="ad-particle"
//           style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.s, height: p.s }}
//           animate={{ y: [0, -20, 0], opacity: [0.08, 0.4, 0.08] }}
//           transition={{ duration: p.d, repeat: Infinity, delay: p.dl, ease: "easeInOut" }}
//         />
//       ))}
//     </div>
//   );
// }

// // ─── Stat Card ─────────────────────────────────────────────────
// function StatCard({ icon, label, value, color, delay }) {
//   return (
//     <motion.div
//       className="ad-stat"
//       initial={{ opacity: 0, y: 20 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       transition={{ delay, duration: 0.5 }}
//       whileHover={{ y: -4 }}
//       style={{ "--stat-color": color }}
//     >
//       <span className="ad-stat-ic">{icon}</span>
//       <div className="ad-stat-info">
//         <b>{value}</b>
//         <span>{label}</span>
//       </div>
//     </motion.div>
//   );
// }

// // ─── Chart Card ────────────────────────────────────────────────
// function ChartCard({ title, icon, children }) {
//   return (
//     <motion.div
//       className="ad-chart"
//       initial={{ opacity: 0, y: 20 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//     >
//       <div className="ad-chart-head">
//         <span className="ad-chart-ic">{icon}</span>
//         <h3>{title}</h3>
//       </div>
//       <div className="ad-chart-body">{children}</div>
//     </motion.div>
//   );
// }

// // ─── Access Denied ─────────────────────────────────────────────
// function AccessDenied() {
//   return (
//     <div className="kk-root ad-denied">
//       <DashParticles />
//       <motion.div
//         className="ad-denied-card"
//         initial={{ opacity: 0, scale: 0.92 }}
//         animate={{ opacity: 1, scale: 1 }}
//       >
//         <div className="ad-denied-ic"><FiAlertCircle /></div>
//         <h2>Access Denied</h2>
//         <p>You don't have permission to view this page.</p>
//         <a href="/login" className="kk-btn kk-btn-gradient kk-btn-sm"><FiLogIn /> Go to Login</a>
//       </motion.div>
//       <Navbar />
//     </div>
//   );
// }

// // ─── Custom Tooltip ────────────────────────────────────────────
// function CustomTooltip({ active, payload, label }) {
//   if (!active || !payload?.length) return null;
//   return (
//     <div className="ad-tooltip">
//       <p className="ad-tip-label">{label}</p>
//       {payload.map((item, i) => (
//         <p key={i} className="ad-tip-val" style={{ color: item.color }}>
//           {item.name}: {item.value}
//         </p>
//       ))}
//     </div>
//   );
// }

// // ─── Main Dashboard Component ──────────────────────────────────
// // LOGIC: identical to your original — same state, same queries, same
// // actions. Only styling/classes + preview fallback added.
// export default function AdminDashboard() {
//   const [logins, setLogins] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [user, setUser] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const rowsPerPage = 10;
//   const navigate = useNavigate();
//   const adminEmail = ADMIN_EMAIL;
//   const { scrollYProgress } = useScroll();
//   const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 28 });

//   // Fetch data
//   useEffect(() => {
//     const current = JSON.parse(localStorage.getItem("user"));
//     setUser(current);

//     if (!db) {
//       // Preview mode: demo admin + demo data so the dashboard is viewable.
//       if (!current) setUser({ Email: ADMIN_EMAIL, Name: "Admin (Demo)" });
//       const t = setTimeout(() => {
//         setUsers(DEMO_USERS);
//         setLogins(DEMO_LOGINS);
//         setLoading(false);
//       }, 600);
//       return () => clearTimeout(t);
//     }

//     getDocs(collection(db, "Register")).then((snap) => {
//       setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
//     });

//     const unsub = onSnapshot(collection(db, "Login"), (snap) => {
//       setLogins(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
//       setLoading(false);
//     });

//     return () => unsub();
//   }, []);

//   if (!user || user.Email !== adminEmail) {
//     return <AccessDenied />;
//   }

//   // Graph data
//   const loginCountPerUser = logins.reduce((acc, l) => {
//     acc[l.Email] = (acc[l.Email] || 0) + 1;
//     return acc;
//   }, {});

//   const graphData = Object.keys(loginCountPerUser).map((email) => ({
//     email: email.split("@")[0],
//     logins: loginCountPerUser[email],
//   }));

//   const activeCount = users.filter((u) => !u.blocked).length;
//   const blockedCount = users.filter((u) => u.blocked).length;

//   const pieData = [
//     { name: "Active", value: activeCount },
//     { name: "Blocked", value: blockedCount },
//   ];

//   const COLORS = ["#22c55e", "#f43f5e"];

//   // Merge users with login data
//   const mergedUsers = users.map((u) => ({
//     ...u,
//     loginCount: loginCountPerUser[u.Email] || 0,
//     lastLogin: logins
//       .filter((log) => log.Email === u.Email)
//       .sort((a, b) => new Date(b.LoginTime) - new Date(a.LoginTime))[0]?.LoginTime || null,
//   }));

//   // Filter and search
//   const filteredUsers = mergedUsers
//     .filter((u) => (u.Name || "").toLowerCase().includes(searchQuery.toLowerCase()))
//     .sort((a, b) => (a.Email === adminEmail ? -1 : 0));

//   // Pagination
//   const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
//   const displayedUsers = filteredUsers.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   // Actions
//   const blockUser = async (email) => {
//     if (!db) {
//       setUsers((p) => p.map((u) => u.Email === email ? { ...u, blocked: true } : u));
//       toast.warning(`${email} blocked.`);
//       return;
//     }
//     const userDoc = users.find((u) => u.Email === email);
//     await updateDoc(doc(db, "Register", userDoc.id), { blocked: true });
//     toast.warning(`${email} blocked.`);
//   };

//   const unblockUser = async (email) => {
//     if (!db) {
//       setUsers((p) => p.map((u) => u.Email === email ? { ...u, blocked: false } : u));
//       toast.success(`${email} unblocked.`);
//       return;
//     }
//     const userDoc = users.find((u) => u.Email === email);
//     await updateDoc(doc(db, "Register", userDoc.id), { blocked: false });
//     toast.success(`${email} unblocked.`);
//   };

//   const deleteLoginHistory = async (email) => {
//     if (!db) {
//       setLogins((p) => p.filter((l) => l.Email !== email));
//       toast.success(`Deleted login history for ${email}`);
//       return;
//     }
//     const snap = await getDocs(query(collection(db, "Login"), where("Email", "==", email)));
//     await Promise.all(snap.docs.map((d) => deleteDoc(doc(db, "Login", d.id))));
//     toast.success(`Deleted login history for ${email}`);
//   };

//   const logout = () => {
//     localStorage.removeItem("user");
//     navigate("/login");
//   };

//   function formatTimestamp(ts) {
//     if (!ts) return "N/A";
//     if (ts.toDate) return ts.toDate().toLocaleString();
//     if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleString();
//     return new Date(ts).toLocaleString();
//   }

//   return (
//     <div className="kk-root ad-page">
//       <motion.div className="kk-progress" style={{ scaleX: progress }} />
//       <DashParticles />
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar
//         theme="dark"
//         toastStyle={{
//           background: "#0a1330",
//           border: "1px solid rgba(46,124,255,.35)",
//           color: "#e9efff",
//         }}
//       />

//       {/* ══════ HEADER ══════ */}
//       <section className="bl-hero">
//         <div className="ab-hero-glow" />
//         <div className="kk-wrap">
//           <div className="pj-head-row">
//             <motion.div
//               initial={{ opacity: 0, y: 26 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7 }}
//             >
//               <p className="kk-label"><FiShield /> Admin</p>
//               <h1 className="ab-title">Analytics <span className="grad">Dashboard</span></h1>
//               <p className="kk-muted bl-sub">Monitor users, logins, and platform activity in real-time.</p>
//             </motion.div>
//             <motion.button
//               className="kk-btn kk-btn-sm pd-delete"
//               onClick={logout}
//               whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
//               initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
//             >
//               <FiLogOut /> Logout
//             </motion.button>
//           </div>
//         </div>
//       </section>

//       {/* ═══════════ MAIN ═══════════ */}
//       <main className="kk-section kk-tight">
//         <div className="kk-wrap">

//           {/* Stats */}
//           <div className="ad-stats">
//             <StatCard icon={<FiUsers />} label="Total Users" value={users.length} color="#2e7cff" delay={0.05} />
//             <StatCard icon={<FiLogIn />} label="Total Logins" value={logins.length} color="#a855f7" delay={0.1} />
//             <StatCard icon={<FiActivity />} label="Active Users" value={activeCount} color="#22c55e" delay={0.15} />
//             <StatCard icon={<FiLock />} label="Blocked Users" value={blockedCount} color="#f43f5e" delay={0.2} />
//           </div>

//           {/* Charts */}
//           <div className="ad-charts">
//             <ChartCard title="Logins Per User" icon={<FiBarChart2 />}>
//               <ResponsiveContainer width="100%" height={250}>
//                 <BarChart data={graphData}>
//                   <XAxis dataKey="email" tick={{ fill: "#8b96b5", fontSize: 11 }} axisLine={false} tickLine={false} />
//                   <YAxis tick={{ fill: "#8b96b5", fontSize: 11 }} axisLine={false} tickLine={false} allowDecimals={false} />
//                   <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(46,124,255,.08)" }} />
//                   <Bar dataKey="logins" fill="#2e7cff" radius={[6, 6, 0, 0]} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </ChartCard>

//             <ChartCard title="User Status" icon={<FiPieChart />}>
//               <ResponsiveContainer width="100%" height={250}>
//                 <PieChart>
//                   <Pie data={pieData} dataKey="value" outerRadius={90} innerRadius={55} label strokeWidth={0}>
//                     {pieData.map((_, i) => (
//                       <Cell key={i} fill={COLORS[i]} />
//                     ))}
//                   </Pie>
//                   <Tooltip content={<CustomTooltip />} />
//                 </PieChart>
//               </ResponsiveContainer>
//               <div className="ad-legend">
//                 <span><i style={{ background: "#22c55e" }} /> Active ({activeCount})</span>
//                 <span><i style={{ background: "#f43f5e" }} /> Blocked ({blockedCount})</span>
//               </div>
//             </ChartCard>
//           </div>

//           {/* User Table */}
//           <motion.div
//             className="ad-table-sec"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//           >
//             <div className="kk-sec-head">
//               <div>
//                 <p className="kk-label">Users</p>
//                 <h2 className="kk-h2">User Activity <span className="grad">Table</span></h2>
//               </div>
//               <div className="bl-search ad-search">
//                 <FiSearch className="bl-search-ic" />
//                 <input
//                   type="text"
//                   placeholder="Search users..."
//                   value={searchQuery}
//                   onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//                 />
//                 {searchQuery && (
//                   <button className="bl-search-x" onClick={() => { setSearchQuery(""); setCurrentPage(1); }}>
//                     <FiX />
//                   </button>
//                 )}
//               </div>
//             </div>

//             {loading ? (
//               <div className="ab-loading"><div className="ab-spinner" /><p>Loading users...</p></div>
//             ) : (
//               <div className="ad-table-wrap">
//                 <table className="ad-table">
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Profile</th>
//                       <th>Name</th>
//                       <th>Email</th>
//                       <th>Contact</th>
//                       <th>Last Login</th>
//                       <th>Logins</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {displayedUsers.map((u, index) => (
//                       <tr key={u.Email} className={u.Email === adminEmail ? "ad-admin-row" : ""}>
//                         <td className="ad-num">{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                         <td>
//                           <img
//                             src={u.PhotoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.Name || "U")}&background=2e7cff&color=fff&size=64`}
//                             className="ad-avatar" alt="avatar"
//                             onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(u.Name || "U")}&background=2e7cff&color=fff&size=64`; }}
//                           />
//                         </td>
//                         <td className="ad-name">
//                           {u.Name || "N/A"}
//                           {u.blocked && <span className="ad-blocked-tag">Blocked</span>}
//                         </td>
//                         <td className="ad-email">{u.Email}</td>
//                         <td>{u.Contact || "N/A"}</td>
//                         <td className="ad-time">{formatTimestamp(u.lastLogin)}</td>
//                         <td><span className="ad-login-badge">{u.loginCount}</span></td>
//                         <td>
//                           <div className="ad-row-btns">
//                             <motion.button
//                               className="cd-icon-btn danger"
//                               onClick={() => deleteLoginHistory(u.Email)}
//                               whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
//                               title="Clear Logs"
//                             >
//                               <FiTrash2 />
//                             </motion.button>
//                             {u.Email !== adminEmail && (
//                               u.blocked ? (
//                                 <motion.button
//                                   className="cd-icon-btn"
//                                   onClick={() => unblockUser(u.Email)}
//                                   whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
//                                   title="Unblock"
//                                 >
//                                   <FiUnlock />
//                                 </motion.button>
//                               ) : (
//                                 <motion.button
//                                   className="cd-icon-btn"
//                                   onClick={() => blockUser(u.Email)}
//                                   whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
//                                   title="Block"
//                                 >
//                                   <FiLock />
//                                 </motion.button>
//                               )
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="ad-pages">
//                 <motion.button
//                   className="ad-page-btn"
//                   disabled={currentPage === 1}
//                   onClick={() => setCurrentPage((p) => p - 1)}
//                   whileHover={{ scale: 1.05 }}
//                 >
//                   <FiChevronLeft />
//                 </motion.button>
//                 <span className="ad-page-info">{currentPage} / {totalPages}</span>
//                 <motion.button
//                   className="ad-page-btn"
//                   disabled={currentPage === totalPages}
//                   onClick={() => setCurrentPage((p) => p + 1)}
//                   whileHover={{ scale: 1.05 }}
//                 >
//                   <FiChevronRight />
//                 </motion.button>
//               </div>
//             )}
//           </motion.div>
//         </div>
//       </main>

//       <Navbar />
//     </div>
//   );
// }


import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import {
  FiUsers, FiLogIn, FiActivity, FiSearch, FiTrash2,
  FiLock, FiLogOut, FiChevronLeft, FiChevronRight,
  FiShield, FiBarChart2, FiPieChart, FiAlertCircle,
  FiX, FiUnlock, FiClock, FiArrowUpRight, FiDatabase,
} from "react-icons/fi";
import {
  collection, onSnapshot, deleteDoc, doc, getDocs,
  query, where, updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Hero.css";           // design system: tokens, .kk-* primitives
import "./AdminDashboard.css"; // everything unique to the admin page

/* ═══════════════ DEMO DATA (preview only — never used with real db) ═══════════════ */

const ADMIN_EMAIL = "karanksxxx@gmail.com";
const now = Math.floor(Date.now() / 1000);

const DEMO_USERS = [
  { id: "u1", Name: "Karan Kumar", Email: ADMIN_EMAIL, Contact: "9041429065", PhotoURL: "", blocked: false },
  { id: "u2", Name: "Aarav Sharma", Email: "aarav@gmail.com", Contact: "9814012345", PhotoURL: "", blocked: false },
  { id: "u3", Name: "Simran Kaur", Email: "simran@gmail.com", Contact: "9876543210", PhotoURL: "", blocked: false },
  { id: "u4", Name: "Rohan Verma", Email: "rohan@gmail.com", Contact: "9000011122", PhotoURL: "", blocked: true },
  { id: "u5", Name: "Priya Singh", Email: "priya@gmail.com", Contact: "9888011223", PhotoURL: "", blocked: false },
  { id: "u6", Name: "Arjun Mehta", Email: "arjun@gmail.com", Contact: "9777011223", PhotoURL: "", blocked: false },
];

const DEMO_LOGINS = [
  { id: "l1", Email: ADMIN_EMAIL, LoginTime: { seconds: now - 3600 } },
  { id: "l2", Email: ADMIN_EMAIL, LoginTime: { seconds: now - 7200 } },
  { id: "l3", Email: "aarav@gmail.com", LoginTime: { seconds: now - 5000 } },
  { id: "l4", Email: "aarav@gmail.com", LoginTime: { seconds: now - 90000 } },
  { id: "l5", Email: "aarav@gmail.com", LoginTime: { seconds: now - 200000 } },
  { id: "l6", Email: "simran@gmail.com", LoginTime: { seconds: now - 8000 } },
  { id: "l7", Email: "simran@gmail.com", LoginTime: { seconds: now - 95000 } },
  { id: "l8", Email: "rohan@gmail.com", LoginTime: { seconds: now - 300000 } },
  { id: "l9", Email: "priya@gmail.com", LoginTime: { seconds: now - 12000 } },
  { id: "l10", Email: "arjun@gmail.com", LoginTime: { seconds: now - 60000 } },
  { id: "l11", Email: "arjun@gmail.com", LoginTime: { seconds: now - 150000 } },
];

const DEMO_COLORS = { active: "#c8ff3d", blocked: "#f43f5e" };

/* ═══════════════ SMALL HELPERS ═══════════════ */

const initials = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || "").join("").toUpperCase() || "U";

const shortEmail = (email = "") => email.split("@")[0];

/* ═══════════════ ONE rAF LOOP — [data-plx] ═══════════════ */

function useParallax(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const items = Array.from(root.querySelectorAll("[data-plx]"));
    let raf = 0;

    const render = () => {
      const vh = window.innerHeight;
      for (const el of items) {
        const speed = parseFloat(el.dataset.plx) || 0;
        const r = el.getBoundingClientRect();
        if (r.bottom < -420 || r.top > vh + 420) continue;
        const y = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
      }
      raf = requestAnimationFrame(render);
    };
    raf = requestAnimationFrame(render);
    return () => cancelAnimationFrame(raf);
  }, [rootRef]);
}

/* ═══════════════ PARTICLES ═══════════════ */

function DashParticles() {
  const parts = useRef(
    Array.from({ length: 18 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      s: Math.random() * 3 + 1,
      d: Math.random() * 12 + 8,
      dl: Math.random() * 5,
    }))
  );
  return (
    <div className="ad-particles" aria-hidden="true">
      {parts.current.map((p) => (
        <motion.span
          key={p.id}
          className="ad-particle"
          style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.s, height: p.s }}
          animate={{ y: [0, -20, 0], opacity: [0.06, 0.32, 0.06] }}
          transition={{ duration: p.d, repeat: Infinity, delay: p.dl, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}

/* ═══════════════ AVATAR (monogram, zero network) ═══════════════ */

function Avatar({ name, src }) {
  const [broken, setBroken] = useState(false);
  if (src && !broken) {
    return (
      <img
        className="ad-avatar"
        src={src}
        alt={name || "avatar"}
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <span className="ad-avatar ad-avatar--mono" aria-hidden="true">
      {initials(name)}
    </span>
  );
}

/* ═══════════════ STAT CARD ═══════════════ */

function StatCard({ icon, label, value, color, delay, share = 0 }) {
  return (
    <motion.div
      className="ad-stat"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.5 }}
      whileHover={{ y: -4 }}
      style={{ "--stat-color": color, "--share": `${Math.min(100, share)}%` }}
    >
      <div className="ad-stat__top">
        <span className="ad-stat__ic">{icon}</span>
        <span className="ad-stat__bar" aria-hidden="true">
          <i />
        </span>
      </div>
      <div className="ad-stat__info">
        <b>{String(value).padStart(2, "0")}</b>
        <span>{label}</span>
      </div>
    </motion.div>
  );
}

/* ═══════════════ CHART CARD ═══════════════ */

function ChartCard({ title, icon, note, children, delay = 0 }) {
  return (
    <motion.div
      className="ad-chart"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
    >
      <div className="ad-chart__head">
        <span className="ad-chart__ic">{icon}</span>
        <div>
          <h3>{title}</h3>
          {note && <p>{note}</p>}
        </div>
      </div>
      <div className="ad-chart__body">{children}</div>
    </motion.div>
  );
}

/* ═══════════════ BAR CHART (hand-drawn, no library) ═══════════════ */

function LoginBars({ data }) {
  if (!data.length) {
    return (
      <p className="ad-chart__empty">
        <FiDatabase /> No logins recorded yet.
      </p>
    );
  }
  const max = Math.max(...data.map((d) => d.logins), 1);
  const rows = Math.min(4, max) + 1;

  return (
    <div className="ad-bars" style={{ "--rows": rows }}>
      <div className="ad-bars__grid" aria-hidden="true">
        {Array.from({ length: rows }).map((_, i) => <span key={i} />)}
      </div>
      <div className="ad-bars__plot">
        {data.map((d, i) => (
          <div className="ad-bar" key={d.email} title={`${d.email} — ${d.logins} login${d.logins > 1 ? "s" : ""}`}>
            <span className="ad-bar__val">{d.logins}</span>
            <span
              className="ad-bar__fill"
              style={{
                height: `${Math.max(6, (d.logins / max) * 100)}%`,
                animationDelay: `${i * 70}ms`,
              }}
            />
            <span className="ad-bar__x">{d.email}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════ DONUT (hand-drawn) ═══════════════ */

function StatusDonut({ active, blocked }) {
  const total = active + blocked;
  const R = 62;
  const C = 2 * Math.PI * R;
  const activePart = total ? active / total : 0;

  return (
    <div className="ad-donut">
      <svg viewBox="0 0 170 170" className="ad-donut__svg" role="img" aria-label={`${active} active, ${blocked} blocked`}>
        <circle cx="85" cy="85" r={R} className="ad-donut__track" />
        <motion.circle
          cx="85" cy="85" r={R}
          className="ad-donut__arc"
          style={{ stroke: DEMO_COLORS.active }}
          strokeDasharray={`${C} ${C}`}
          initial={{ strokeDashoffset: C }}
          whileInView={{ strokeDashoffset: C - C * activePart }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          transform="rotate(-90 85 85)"
        />
        <motion.circle
          cx="85" cy="85" r={R}
          className="ad-donut__arc"
          style={{ stroke: DEMO_COLORS.blocked }}
          strokeDasharray={`${C} ${C}`}
          initial={{ strokeDashoffset: C }}
          whileInView={{ strokeDashoffset: C - C * (1 - activePart) }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          transform={`rotate(${-90 + activePart * 360} 85 85)`}
        />
        <text x="85" y="80" className="ad-donut__num">{total}</text>
        <text x="85" y="100" className="ad-donut__cap">users</text>
      </svg>

      <div className="ad-legend">
        <span><i style={{ background: DEMO_COLORS.active }} /> Active <b>{active}</b></span>
        <span><i style={{ background: DEMO_COLORS.blocked }} /> Blocked <b>{blocked}</b></span>
      </div>
    </div>
  );
}

/* ═══════════════ ACCESS DENIED ═══════════════ */

function AccessDenied() {
  return (
    <div className="kk-root ad-page ad-page--denied">
      <DashParticles />
      <Navbar />
      <main className="ad-denied">
        <div className="ad-denied__bg" aria-hidden="true">
          <span data-plx="0.08" />
          <span data-plx="0.14" />
        </div>

        <motion.div
          className="ad-denied__card"
          initial={{ opacity: 0, y: 24, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="ad-denied__ic"><FiAlertCircle /></span>
          <span className="ad-eyebrow">Restricted / 403</span>
          <h2>Access <span className="kk-serif">denied.</span></h2>
          <p>This dashboard is limited to the site owner. Sign in with the admin account to continue.</p>
          <div className="ad-denied__btns">
            <a className="kk-btn" href="/login"><FiLogIn /> Go to login</a>
            <a className="kk-btn kk-btn--ghost" href="/">Back home <FiArrowUpRight /></a>
          </div>
          <span className="ad-denied__lock"><FiLock /> KKS·1436 — admin only</span>
        </motion.div>
      </main>
    </div>
  );
}

/* ═══════════════ MAIN DASHBOARD ═══════════════ */

export default function AdminDashboard() {
  const [logins, setLogins] = useState([]);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("user"));
      if (saved) return saved;
    } catch {
      /* ignore malformed storage */
    }
    // Preview build: no firebase, so sign in as the demo admin.
    return db ? null : { Email: ADMIN_EMAIL, Name: "Karan Kumar (Demo)" };
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const rowsPerPage = 10;
  const navigate = useNavigate();
  const adminEmail = ADMIN_EMAIL;

  const rootRef = useRef(null);
  useParallax(rootRef);

  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 28 });

  // Fetch data
  useEffect(() => {
    const current = JSON.parse(localStorage.getItem("user"));
    setUser(current);

    if (!db) {
      if (!current) setUser({ Email: ADMIN_EMAIL, Name: "Karan Kumar (Demo)" });
      const t = setTimeout(() => {
        setUsers(DEMO_USERS);
        setLogins(DEMO_LOGINS);
        setLoading(false);
      }, 600);
      return () => clearTimeout(t);
    }

    getDocs(collection(db, "Register")).then((snap) => {
      setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    const unsub = onSnapshot(collection(db, "Login"), (snap) => {
      setLogins(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });

    return () => unsub();
  }, []);

  if (!user || user.Email !== adminEmail) {
    return <AccessDenied />;
  }

  // Graph data
  const loginCountPerUser = logins.reduce((acc, l) => {
    acc[l.Email] = (acc[l.Email] || 0) + 1;
    return acc;
  }, {});

  const graphData = Object.keys(loginCountPerUser).map((email) => ({
    email: email.split("@")[0],
    logins: loginCountPerUser[email],
  }));

  const activeCount = users.filter((u) => !u.blocked).length;
  const blockedCount = users.filter((u) => u.blocked).length;

  // Merge users with login data
  const mergedUsers = users.map((u) => ({
    ...u,
    loginCount: loginCountPerUser[u.Email] || 0,
    lastLogin: logins
      .filter((log) => log.Email === u.Email)
      .sort((a, b) => new Date(b.LoginTime) - new Date(a.LoginTime))[0]?.LoginTime || null,
  }));

  // Filter and search
  const filteredUsers = mergedUsers
    .filter((u) => (u.Name || "").toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a) => (a.Email === adminEmail ? -1 : 0));

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const displayedUsers = filteredUsers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Actions
  const blockUser = async (email) => {
    if (!db) {
      setUsers((p) => p.map((u) => (u.Email === email ? { ...u, blocked: true } : u)));
      toast.warning(`${email} blocked.`);
      return;
    }
    const userDoc = users.find((u) => u.Email === email);
    await updateDoc(doc(db, "Register", userDoc.id), { blocked: true });
    toast.warning(`${email} blocked.`);
  };

  const unblockUser = async (email) => {
    if (!db) {
      setUsers((p) => p.map((u) => (u.Email === email ? { ...u, blocked: false } : u)));
      toast.success(`${email} unblocked.`);
      return;
    }
    const userDoc = users.find((u) => u.Email === email);
    await updateDoc(doc(db, "Register", userDoc.id), { blocked: false });
    toast.success(`${email} unblocked.`);
  };

  const deleteLoginHistory = async (email) => {
    if (!db) {
      setLogins((p) => p.filter((l) => l.Email !== email));
      toast.success(`Deleted login history for ${email}`);
      return;
    }
    const snap = await getDocs(query(collection(db, "Login"), where("Email", "==", email)));
    await Promise.all(snap.docs.map((d) => deleteDoc(doc(db, "Login", d.id))));
    toast.success(`Deleted login history for ${email}`);
  };

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  function formatTimestamp(ts) {
    if (!ts) return "N/A";
    if (ts.toDate) return ts.toDate().toLocaleString();
    if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleString();
    return new Date(ts).toLocaleString();
  }

  const totalLogins = logins.length || 1;

  return (
    <div className="kk-root ad-page" ref={rootRef}>
      <motion.div className="kk-progress" style={{ scaleX: progress }} />
      <DashParticles />
      <Navbar />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        theme="dark"
        toastStyle={{
          background: "#0b0b10",
          border: "1px solid rgba(200,255,61,.28)",
          color: "#f3f3f5",
        }}
      />

      {/* ══════════ HEADER ══════════ */}
      <header className="ad-hero">
        <div className="ad-hero__bg" aria-hidden="true">
          <span className="ad-hero__grid" data-plx="0.04" />
          <span className="ad-hero__glow ad-hero__glow--acid" data-plx="0.14" />
          <span className="ad-hero__glow ad-hero__glow--violet" data-plx="0.22" />
          <span className="ad-hero__word" data-plx="0.08">ADMIN</span>
        </div>

        <div className="kk-wrap ad-hero__in">
          <motion.div
            className="ad-hero__copy"
            initial={{ opacity: 0, y: 26 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="ad-eyebrow">
              <span className="ad-dot" />
              <span>Admin</span>
              <span className="kk-slash">/</span>
              <span>Control room</span>
            </div>

            <h1 className="ad-title">
              Analytics <span className="kk-serif kk-acid">dashboard</span>
              <span className="ad-title__sub">users, sessions, signals.</span>
            </h1>

            <p className="ad-lead">
              Every account, every login and every block — read straight from
              <code>Register</code> and <code>Login</code> in real time.
            </p>

            <div className="ad-hero__meta">
              <span><FiUsers /> {users.length} accounts</span>
              <span><FiLogIn /> {logins.length} logins</span>
              <span className={loading ? "is-live" : ""}><i /> {loading ? "syncing" : "live"}</span>
            </div>
          </motion.div>

          <motion.aside
            className="ad-session"
            initial={{ opacity: 0, y: 26 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="ad-session__tag"><FiShield /> Signed in</span>
            <div className="ad-session__id">
              <Avatar name={user.Name} src={user.PhotoURL} />
              <div>
                <b>{user.Name || "Admin"}</b>
                <span>{user.Email}</span>
              </div>
            </div>
            <div className="ad-session__rows">
              <span><FiClock /> {new Date().toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })}</span>
              <span><FiDatabase /> {db ? "Firestore" : "Demo data"}</span>
            </div>
            <button className="kk-btn kk-btn--ghost ad-btn-sm ad-session__out" onClick={logout}>
              <FiLogOut /> Logout
            </button>
          </motion.aside>
        </div>
      </header>

      {/* ══════════ STATS + CHARTS ══════════ */}
      <section className="ad-sec">
        <div className="kk-wrap">
          <div className="ad-stats">
            <StatCard
              icon={<FiUsers />} label="Total users" value={users.length}
              color="#c8ff3d" delay={0.05} share={users.length ? 100 : 0}
            />
            <StatCard
              icon={<FiLogIn />} label="Total logins" value={logins.length}
              color="#8b6bff" delay={0.1} share={(logins.length / totalLogins) * 100}
            />
            <StatCard
              icon={<FiActivity />} label="Active users" value={activeCount}
              color="#4ce0ff" delay={0.15}
              share={users.length ? (activeCount / users.length) * 100 : 0}
            />
            <StatCard
              icon={<FiLock />} label="Blocked users" value={blockedCount}
              color="#f43f5e" delay={0.2}
              share={users.length ? (blockedCount / users.length) * 100 : 0}
            />
          </div>

          <div className="ad-charts">
            <ChartCard
              title="Logins per user"
              icon={<FiBarChart2 />}
              note={`${logins.length} sessions across ${graphData.length} account${graphData.length === 1 ? "" : "s"}`}
            >
              <LoginBars data={graphData} />
            </ChartCard>

            <ChartCard
              title="Account status"
              icon={<FiPieChart />}
              note="Active vs blocked"
              delay={0.1}
            >
              <StatusDonut active={activeCount} blocked={blockedCount} />
            </ChartCard>
          </div>
        </div>
      </section>

      {/* ══════════ TABLE ══════════ */}
      <section className="ad-sec ad-sec--table">
        <div className="kk-wrap">
          <motion.div
            className="ad-table-sec"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="ad-table-head">
              <div>
                <span className="ad-eyebrow"><span className="ad-dot" /> 01 — Users</span>
                <h2 className="ad-h2">User activity <span className="kk-serif">table</span></h2>
              </div>

              <div className="ad-search">
                <FiSearch className="ad-search__ic" />
                <input
                  type="text"
                  placeholder="Search by name…"
                  value={searchQuery}
                  onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                  aria-label="Search users"
                />
                {searchQuery && (
                  <button
                    className="ad-search__x"
                    onClick={() => { setSearchQuery(""); setCurrentPage(1); }}
                    aria-label="Clear search"
                  >
                    <FiX />
                  </button>
                )}
              </div>
            </div>

            {loading ? (
              <div className="ad-skelwrap" aria-hidden="true">
                {Array.from({ length: 6 }).map((_, i) => <span className="ad-skel" key={i} />)}
              </div>
            ) : displayedUsers.length === 0 ? (
              <div className="ad-empty">
                <span className="ad-empty__ic"><FiSearch /></span>
                <b>No users match “{searchQuery}”</b>
                <p>Try a different name, or clear the search to see everyone.</p>
                <button className="kk-btn kk-btn--ghost ad-btn-sm" onClick={() => { setSearchQuery(""); setCurrentPage(1); }}>
                  Clear search
                </button>
              </div>
            ) : (
              <div className="ad-table-wrap">
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Profile</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Contact</th>
                      <th>Last login</th>
                      <th>Logins</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedUsers.map((u, index) => (
                      <tr key={u.Email} className={u.Email === adminEmail ? "ad-row--admin" : ""}>
                        <td className="ad-num">{String((currentPage - 1) * rowsPerPage + index + 1).padStart(2, "0")}</td>
                        <td><Avatar name={u.Name} src={u.PhotoURL} /></td>
                        <td className="ad-name">
                          <span>{u.Name || "N/A"}</span>
                          {u.Email === adminEmail && <em className="ad-you">you</em>}
                          {u.blocked && <em className="ad-blocked-tag">blocked</em>}
                        </td>
                        <td className="ad-email">{u.Email}</td>
                        <td className="ad-contact">{u.Contact || "—"}</td>
                        <td className="ad-time">{formatTimestamp(u.lastLogin)}</td>
                        <td><span className="ad-login-badge">{u.loginCount}</span></td>
                        <td>
                          <div className="ad-row-btns">
                            <motion.button
                              className="ad-icon-btn ad-icon-btn--danger"
                              onClick={() => deleteLoginHistory(u.Email)}
                              whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
                              title="Clear logs"
                              aria-label={`Clear login history for ${u.Email}`}
                            >
                              <FiTrash2 />
                            </motion.button>
                            {u.Email !== adminEmail && (
                              u.blocked ? (
                                <motion.button
                                  className="ad-icon-btn"
                                  onClick={() => unblockUser(u.Email)}
                                  whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
                                  title="Unblock"
                                  aria-label={`Unblock ${u.Email}`}
                                >
                                  <FiUnlock />
                                </motion.button>
                              ) : (
                                <motion.button
                                  className="ad-icon-btn"
                                  onClick={() => blockUser(u.Email)}
                                  whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
                                  title="Block"
                                  aria-label={`Block ${u.Email}`}
                                >
                                  <FiLock />
                                </motion.button>
                              )
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p className="ad-scroll-hint" aria-hidden="true">Swipe the table sideways →</p>
              </div>
            )}

            {totalPages > 1 && (
              <div className="ad-pager">
                <motion.button
                  className="ad-page-btn"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                  whileHover={{ scale: 1.05 }}
                  aria-label="Previous page"
                >
                  <FiChevronLeft />
                </motion.button>
                <span className="ad-page-info">
                  <b>{String(currentPage).padStart(2, "0")}</b> / {String(totalPages).padStart(2, "0")}
                </span>
                <motion.button
                  className="ad-page-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                  whileHover={{ scale: 1.05 }}
                  aria-label="Next page"
                >
                  <FiChevronRight />
                </motion.button>
              </div>
            )}
          </motion.div>
        </div>
      </section>

      {/* ══════════ FOOT ══════════ */}
      <footer className="ad-foot">
        <div className="kk-wrap ad-foot__in">
          <span>KKS·1436 — admin console</span>
          <span className="ad-foot__mid">Register · Login · live sync</span>
          <button className="ad-foot__out" onClick={logout}><FiLogOut /> Logout</button>
        </div>
      </footer>
    </div>
  );
}
